<template>
  <div class="dashboard body">
    <el-container>
      <!-- <Aside /> -->
      <el-main>
        <div style="margin-top: -11px">
          <el-button
            plain
            @click="setSelectedInvoice(index)"
            style="margin-right: 5px"
            v-for="(invoice, index) in sales"
            :key="index"
            :type="selectedIndex == index ? 'warning' : 'success'"
          >
            {{ index + 1 }}
          </el-button>
          <el-button
            plain
            type="primary"
            style="margin-right: 5px"
            @click="addNewInvoice"
          >
            <i class="fas fa-plus"></i>
          </el-button>
        </div>
        <SearchCustomers
          :customer="sales[selectedIndex].customer"
          @selectedCustomer="selectedCustomer"
          :productsLength="sales[selectedIndex].products.length"
        />
        <el-row class="table mt-2 px-3">
          <div
            class="
              el-table
              el-table--fit
              el-table--border
              el-table--scrollable-y
              el-table--enable-row-hover
              el-table--enable-row-transition
            "
            style="margin-top: 20px; height: 59vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="30%" />
                  <col name="el-table_3_column_13" width="15%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="7%" />
                  <col name="el-table_3_column_19" width="10%" />
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الوحدة</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">سعر البيع</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">أخر سعر</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell"></div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              ref="products_table"
              style="height: auto; max-height: 45vh"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__body"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="30%" />
                  <col name="el-table_3_column_13" width="15%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="7%" />
                  <col name="el-table_3_column_19" width="10%" />
                </colgroup>
                <!-- id="order" -->
                <tbody class="body">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in sales[selectedIndex].products"
                    :key="index"
                  >
                    <td rowspan="1" colspan="1" class="el-table_3_column_11">
                      <div class="cell num">{{ index + 1 }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_12">
                      <div class="cell">{{ item.name }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_13">
                      <div class="cell">
                        {{ item.unit.unit }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_14">
                      <div class="cell">
                        <el-input-number
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.qty"
                          controls-position="right"
                        ></el-input-number>
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_15">
                      <div class="cell">
                        <el-input-number
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.sale_price"
                          controls-position="right"
                        ></el-input-number>
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_16">
                      <div class="cell center">
                        {{ numberToFixed(item.lastSaleCost) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_17">
                      <div class="cell center">
                        {{ numberToFixed(item.sale_price * item.qty) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_18">
                      <div class="cell center">{{ item.stock }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_19">
                      <div class="cell">
                        <div
                          class="deleteicon"
                          @click="activeDelete = !activeDelete"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </div>
                        <div class="center">
                          <vs-dialog v-model="activeDelete">
                            <p class="text-delete">هل انت متاكد ؟</p>

                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-button
                                  class="no"
                                  @click="activeDelete = !activeDelete"
                                >
                                  لا</el-button
                                >
                              </el-col>
                              <el-col :span="12">
                                <el-button
                                  class="yes"
                                  @click="
                                    deleteItem(item, index),
                                      (activeDelete = !activeDelete)
                                  "
                                  >نعم</el-button
                                >
                              </el-col>
                            </el-row>
                          </vs-dialog>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
            <div class="el-table__footer-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__footer"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="30%" />
                  <col name="el-table_3_column_13" width="15%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="7%" />
                  <col name="el-table_3_column_19" width="10%" />
                </colgroup>
                <tbody class="has-gutter footer">
                  <tr>
                    <!-- <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell num">{{ ind + 1 }}</div>
                    </td> -->
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">
                        <!-- value-key="name" -->
                        <div class="searchInput">
                          <SearchProducts
                            :customer="customer"
                            @selectedProduct="selectedProduct"
                          />
                        </div>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">
                        <el-select
                          v-model="selectedUnit"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="unit in productUnits"
                            :key="unit.id"
                            :label="unit.unit"
                            :value="unit"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell qty">
                        <el-input
                          type="text"
                          ref="qty"
                          @focus="$event.target.select()"
                          @keyup.enter.native="setPriceFocus"
                          v-model="qty"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell sale_price">
                        <el-input
                          type="text"
                          ref="sale_price"
                          v-model="sale_price"
                          @focus="$event.target.select()"
                          @keyup.enter.native="addNewItem"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">
                        {{ selectedProductlastSaleCost }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center" v-if="qty * sale_price > 0">
                        {{ qty * sale_price }}
                      </div>
                      <div class="cell center" v-else>-</div>
                    </td>
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">{{ selectedProductStock }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-row>
        <el-row
          :gutter="10"
          class="footer"
          v-if="sales[selectedIndex].products.length > 0"
        >
          <el-col :xl="8" :lg="8" :md="18" :sm="24"
            ><div class="bg-White alignment px-3 mt-2">
              <el-row :gutter="5">
                <el-col :span="8"
                  ><el-input placeholder="قيمه الخصم" align="middle"></el-input>
                </el-col>
                <el-col :span="16"
                  ><el-input placeholder="الخصم بالنسبة المئوية"></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="18" :sm="24"
            ><div class="bg-White alignment p-3 mt-2">
              <p>
                الكميه
                <span class="num">{{ sales[selectedIndex].total_qty }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" :md="6" :sm="24"
            ><div class="bg-White alignment mt-2">
              <p class="px-3">
                اجمالي الفاتوره
                <span>{{
                  numberToFixed(sales[selectedIndex].total_sale_cost)
                }}</span>
              </p>
              <el-button class="exit" @click="removeSelectedOrder"
                >الغاء</el-button
              >
              <el-button class="mr-3 save" :loading="isLoading" @click="addSale"
                >حفظ الفاتوره</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Aside from "../components/aside.vue";
import SearchCustomers from "../components/Customers/Search";
import SearchProducts from "../components/Products/SearchWithLastSalePrice";
import axiosApi from "@/plugins/axios.js";

export default {
  components: { Aside, SearchCustomers, SearchProducts },
  name: "Dashboard",
  data: () => ({
    isLoading: false,
    customer: null,
    product: null,
    productUnits: [],
    selectedUnit: null,
    sale_price: "",
    min_price: "",
    qty: "",
    active: "sales",

    timeout: null,
    selectedProductlastSaleCost: "-",
    selectedProductStock: "-",
    value: "",
    num: 1,
    ind: 0,

    activeDelete: false,

    selectedIndex: 0,
    showPrice: false,
    sales: [
      {
        inventory_id: 1,
        // createdAt: this.$moment().locale("en").format().substring(0, 16),
        // createdBy: JSON.parse(Cookies.get("current_user")).user.name,

        // donne_at: this.$moment().locale("en").format("YYYY-MM-DD"),
        // inventory_id: JSON.parse(Cookies.get("current_user")).inventories[0]
        //   .id,
        paied: 0,
        VAT: 0,
        customer: null,

        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        total_discount: 0,
        percentage_discount: 0,

        products: [],
      },
    ],
  }),
  created() {
    if (localStorage.getItem("sales")) {
      let sale_data = localStorage.getItem("sales");

      this.sales = JSON.parse(sale_data);
      // this.checkOrderStock();
      this.customer = this.sales[this.selectedIndex].customer;

      // if (this.sales[this.selectedIndex].customer != null) {
      //   this.getCustomerAccount();
      // } else {
      //   this.customer = null;
      //   this.sales[this.selectedIndex].customer = null;
      // }
      this.calcTotal();
    }
  },
  methods: {
    alert() {
      alert("price clicked");
    },
    removeSelectedOrder() {
      this.$confirm("هل تريد إلغاء الفاتورة ؟", "تحذير", {
        confirmButtonText: "موافق",
        cancelButtonText: "رفض",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.resetInvoiceData();

          this.$message({
            type: "success",
            message: "تم المسح بنجاح",
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'تم إلغاء'
          // });
        });
    },
    setSelectedInvoice(index) {
      this.selectedIndex = index;
      this.customer = this.sales[index].customer;
      if (this.sales[index].customer != null) {
        document.querySelector(".productQuery input").focus();
      } else {
        document.querySelector(".customerQuery input").value = "";
        document.querySelector(".customerQuery input").focus();
      }
    },
    addNewInvoice() {
      this.sales.push({
        inventory_id: 1,
        customer: null,
        paied: 0,
        VAT: 0,
        total_cost: 0,
        total_qty: 0,
        total_discount: 0,
        percentage_discount: 0,
        products: [],
      });
      // alert(this.sale.length);
      this.selectedIndex = this.sales.length - 1;
    },
    setPriceFocus() {
      document.querySelector(".sale_price input").focus();
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      this.sales[this.selectedIndex].customer = e.customer;
      this.setLocalStorage();
      document.querySelector(".productQuery input").focus();
      // this.getCustomerAccount();
    },

    selectedProduct(e) {
      this.product = e.product;
      this.productUnits = e.product.prices;
      if (e.product.prices.length == 1) {
        this.selectedUnit = e.product.prices[0];
        this.sale_price = this.selectedUnit.sale_price;
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductStock =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package +
          " " +
          this.productUnits[0].unit;
        if (e.product.mainUnitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.mainUnitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }

        setTimeout(() => {
          document.querySelector(".qty input").focus();
        }, 200);
      }
      // this.$refs.productSearch.focus();
    },
    addNewItem() {
      if (this.product.inventories.length == 0) {
        this.$snotify.error(` ${this.product.name} عفوا لا يوجد مخزون من `);
      } else {
        let barcode = this.selectedUnit.code;
        let unit_type = this.selectedUnit.type;
        let products = [];
        // ! check qty to hold
        let selectedProduct = {
          product_id: this.product.id,
          qty: this.qty,
          unit_type: unit_type,
          // inventory_id: JSON.parse(Cookies.get("current_user")).inventories[0].id,
          inventory_id: 1,
          units_per_package: this.product.units_per_package,
        };
        products.push(selectedProduct);

        axiosApi
          .post(`products/hold`, { products: products })
          .then((res) => {
            let available_qty = res.data.qty;
            if (unit_type == 1) {
              available_qty = res.data.qty / this.product.units_per_package;
            }

            var product = this.sales[this.selectedIndex].products.filter(
              function (elem) {
                if (elem.barcode == barcode) return elem;
              }
            );

            if (product.length > 0) {
              this.sales[this.selectedIndex].products.splice(
                this.sales[this.selectedIndex].products.findIndex(
                  (e) => e.barcode == barcode
                ),
                1
              );

              if (available_qty >= this.qty) {
                this.sales[this.selectedIndex].products.push({
                  id: product[0].id,
                  name: product[0].name,
                  barcode: product[0].barcode,
                  units_per_package: product[0].units_per_package,
                  unit: product[0].unit,
                  units: product[0].units,
                  unit_type: product[0].unit_type,
                  sale_price: product[0].sale_price,
                  min_price: product[0].min_price,
                  buy_cost: product[0].buy_cost,
                  stock: available_qty,
                  lastSaleCost: product[0].lastSaleCost,
                  qty: Number(product[0].qty) + Number(this.qty),
                });

                this.clearProduct();
                this.setLocalStorage();
              } else {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: `عفوا المخزن المتاح فقط ${available_qty} ${product[0].unit}`,
                  duration: 1500,
                });
              }
            } else {
              let buy_cost = 0;
              let stock = 0;
              let lastSaleCost = "";

              if (this.selectedUnit.type == 1) {
                if (this.product.mainUnitLastInvoice != null) {
                  lastSaleCost = this.product.mainUnitLastInvoice.sale_price;
                }
              } else if (this.selectedUnit.type == 2) {
                if (this.product.secondUnitLastInvoice != null) {
                  lastSaleCost = this.product.secondUnitLastInvoice.sale_price;
                }
              } else {
                lastSaleCost = "";
              }
              let qty = 0;
              if (this.product.inventories.length > 0) {
                qty =
                  this.product.inventories[0].pivot.qty -
                  this.product.inventories[0].pivot.hold_qty;
                if (this.selectedUnit.type == 1) {
                  buy_cost = this.product.inventories[0].pivot.buy_cost;

                  stock = Number(qty / this.product.units_per_package);
                } else {
                  buy_cost =
                    this.product.inventories[0].pivot.buy_cost /
                    this.product.units_per_package;
                  stock = qty;
                }
              }

              if (stock >= this.qty) {
                this.sales[this.selectedIndex].products.push({
                  id: this.product.id,
                  name: this.product.name,
                  barcode: barcode,
                  units_per_package: this.product.units_per_package,
                  unit: this.selectedUnit,
                  unit_type: this.selectedUnit.type,
                  units: this.product.prices,
                  sale_price: this.sale_price,
                  min_price: this.min_price,
                  buy_cost: buy_cost,
                  stock: stock,
                  lastSaleCost: lastSaleCost,
                  qty: Number(this.qty),
                });
                this.setLocalStorage();
                this.calcTotal();

                this.clearProduct();
              } else {
                console.log("there is no stock for selected product");
              }
            }
          })
          .catch(() => {
            this.$notify.error({
              title: "حدث خطأ",
              message: `عفوا المخزن المتاح لا يكفي `,
              duration: 1500,
            });
          });
        // end hold
      }

      this.scrollToEnd();
    },
    addSale() {
      if (this.sales[this.selectedIndex].products.length > 0) {
        this.isLoading = true;
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axiosApi
          .post("sales", this.sales[this.selectedIndex])
          .then((response) => {
            this.invoice_details = response.data.invoice_details;
            localStorage.setItem(
              "sale_invoice",
              JSON.stringify(response.data.invoice_details)
            );

            this.resetInvoiceData();
            this.$notify({
              title: "تمت العملية بنجاح",
              message: "تم حفظ بيانات الفاتورة بنجاح",
              type: "success",
              duration: 1500,
            });
          })
          .catch(() => {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات الفاتورة",
              duration: 1500,
            });
          })
          .finally(() => {
            loading.close();
            this.isLoading = false;
          });
      }
    },
    calcTotal() {
      let buy_cost = 0;
      let sale_total = 0;
      this.allowSale = true;

      var qty = 0;

      for (var i = 0; i < this.sales[this.selectedIndex].products.length; i++) {
        if (
          this.sales[this.selectedIndex].products[i].buy_cost >
          this.sales[this.selectedIndex].products[i].sale_price
        ) {
          this.allowSale = false;
          // this.$snotify.warning(
          //   " تنبيه أنت تحاول بيع" + " "+
          //     this.sales[this.selectedIndex].products[i].name +
          //     " بأقل من سعر الشراء"
          // );
        }
        if (this.sales[this.selectedIndex].products[i].qty == "") {
          this.sales[this.selectedIndex].products[i].qty = 1;
        }
        let buy =
          this.sales[this.selectedIndex].products[i].qty *
          this.sales[this.selectedIndex].products[i].buy_cost;

        buy_cost = buy_cost + buy;
        let sale =
          this.sales[this.selectedIndex].products[i].qty *
          this.sales[this.selectedIndex].products[i].sale_price;

        sale_total = sale_total + sale;

        qty = qty + Number(this.sales[this.selectedIndex].products[i].qty);
      }
      this.checkQty();
      this.sales[this.selectedIndex].total_buy_cost = Number(buy_cost);
      this.sales[this.selectedIndex].total_sale_cost = Number(sale_total);
      this.sales[this.selectedIndex].total_qty = Number(qty);

      this.setLocalStorage();
    },
    checkQty() {
      for (var i = 0; i < this.sales[this.selectedIndex].products.length; i++) {
        if (Number(this.sales[this.selectedIndex].products[i].qty) == 0) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (
          Number(this.sales[this.selectedIndex].products[i].qty) >
          Number(this.sales[this.selectedIndex].products[i].stock)
        ) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }

        if (this.sales[this.selectedIndex].products[i].qty == "") {
          this.sales[this.selectedIndex].products[i].qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("sales", JSON.stringify(this.sales));
    },
    clearProduct() {
      this.qty = "";
      this.selectedProductStock = "-";
      this.selectedProductlastSaleCost = "-";
      this.sale_price = "";
      this.product = null;
      this.selectedUnit = null;
      this.productUnits = [];
      //  this.$refs.productQuery.value = ''
      setTimeout(() => {
        document.querySelector(".productQuery input").value = "";
        document.querySelector(".productQuery input").focus();
      }, 100);
    },
    resetInvoiceData() {
      // this.products = null;
      this.customer = null;

      if (this.sales.length > 1) {
        this.sales.splice(this.selectedIndex, 1);
        this.selectedIndex = 0;
      } else {
        this.sales[this.selectedIndex].products = [];
        // this.sales[this.selectedIndex].donne_at = this.$moment()
        //   .locale("en")
        //   .format("YYYY-MM-DD");

        this.sales[this.selectedIndex].customer = null;

        this.sales[this.selectedIndex].total_cost = 0;
        this.sales[this.selectedIndex].paied = 0;
        this.sales[this.selectedIndex].total_buy_cost = 0;
        this.sales[this.selectedIndex].total_sale_cost = 0;
        this.sales[this.selectedIndex].total_qty = 0;
        this.sales[this.selectedIndex].total_discount = 0;
        this.sales[this.selectedIndex].percentage_discount = 0;
        this.selectedIndex = 0;
      }
      setTimeout(() => {
        document.querySelector(".customerQuery input").value = "";
        document.querySelector(".customerQuery input").focus();
      }, 100);
      localStorage.setItem("sales", JSON.stringify(this.sales));
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    deleteItem(product, index) {
      // alert(index);
      this.holdProduct(product, product.unit_type, product.qty * -1);

      this.sales[this.selectedIndex].products.splice(index, 1);
      this.calcTotal();
    },
    holdProduct(product, unit_type, qty) {
      let products = [];
      let selectedProduct = {
        product_id: product.id,
        qty: qty,
        unit_type: unit_type,
        inventory_id: 1,
        // inventory_id: JSON.parse(Cookies.get("current_user")).inventories[0].id,
        units_per_package: product.units_per_package,
      };

      products.push(selectedProduct);

      axiosApi.post(`products/hold`, { products: products }).then((res) => {
        let available_qty = res.data.qty;
        if (unit_type == 1) {
          available_qty = res.data.qty / product.units_per_package;
        }

        return available_qty;
      });
    },

    scrollToEnd() {
      let elementToScrollDown = this.$refs.products_table;
      elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
    },
  },
  mounted() {},
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
</style>
